import { Link } from "react-router-dom";
import { faRating, toFa } from "../../lib/format";
import { useReveal } from "../../lib/motion";
import "./ui.css";

/** Scroll-revealed wrapper. `as` keeps the semantic element intact. */
export function Reveal({ as: Tag = "div", className = "", delay, lift, children, ...rest }) {
  const ref = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal${lift ? " reveal--lift" : ""} ${className}`}
      style={delay ? { "--reveal-delay": `${delay}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export function Stars({ rating, reviews, className = "" }) {
  const full = Math.round(rating);
  return (
    <span className={`stars ${className}`}>
      <span className="stars__marks" aria-hidden="true">
        {"★★★★★".slice(0, full)}
        <span className="stars__empty">{"★★★★★".slice(full)}</span>
      </span>
      <span className="stars__num">{faRating(rating)}</span>
      {reviews ? <span className="stars__count">({toFa(reviews)})</span> : null}
      <span className="sr-only">
        امتیاز {faRating(rating)} از ۵
      </span>
    </span>
  );
}

export function SectionHead({ eyebrow, title, lede, to, toLabel, light = false }) {
  return (
    <Reveal className="sec-head">
      <div>
        {eyebrow && (
          <span className={`eyebrow${light ? " eyebrow--light" : ""}`}>{eyebrow}</span>
        )}
        <h2 className="sec-head__title" dangerouslySetInnerHTML={{ __html: title }} />
      </div>

      <div className="sec-head__aside">
        {lede && <p className="sec-head__lede">{lede}</p>}
        {to && (
          <Link to={to} className="tlink">
            {toLabel}
            <span className="tlink__arrow">←</span>
          </Link>
        )}
      </div>
    </Reveal>
  );
}

export function Pill({ active, children, ...rest }) {
  return (
    <button type="button" className={`pill${active ? " is-active" : ""}`} {...rest}>
      {children}
    </button>
  );
}
